const messages = {
  step3: {
    actionBtn: "Logg inn",
  },
};

export default {
  messages,
};
